import { render, staticRenderFns } from "./BotaoVoltar.vue?vue&type=template&id=59b67326&scoped=true&"
import script from "./BotaoVoltar.vue?vue&type=script&lang=js&"
export * from "./BotaoVoltar.vue?vue&type=script&lang=js&"
import style0 from "./BotaoVoltar.vue?vue&type=style&index=0&id=59b67326&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b67326",
  null
  
)

export default component.exports